import { render, staticRenderFns } from "./UpdateSideCard.vue?vue&type=template&id=36102bde&"
import script from "./UpdateSideCard.vue?vue&type=script&lang=ts&"
export * from "./UpdateSideCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports